import { StandardConfigurationBase } from './base/standard-configuration-base';

export class StandardConfiguration extends StandardConfigurationBase { }